// useBacktestSummary — fetches /api/backtest/summary once and returns
// a formatted headline plus the raw payload. Landing + Methodology use
// this so the accuracy figure they display is *always* the live
// backtest number — never a hardcoded string.
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export function useBacktestSummary() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const r = await fetch(`${API}/api/backtest/summary`, { credentials: "include" });
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                const d = await r.json();
                if (alive) setData(d);
            } catch (e) {
                if (alive) setError(String(e.message || e));
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, []);

    // Convenience getters.
    const dir = data?.overall?.direction?.score;
    const cov = data?.overall?.coverage?.score;
    const scored = data?.scored_cases;
    const engine = data?.engine_version;

    const headline =
        loading ? "Measuring live accuracy against validated historical decisions…"
        : error   ? "Accuracy backtest not available right now."
        : (dir == null || scored == null)
            ? "Accuracy backtest is in early data mode."
            : `${(dir * 100).toFixed(1)}% direction accuracy across ${scored} validated historical decisions.`;

    return { data, loading, error, headline, direction: dir, coverage: cov, scored, engineVersion: engine };
}
